module.exports = __webpack_public_path__ + "static/cordova-216157ed3259375c83aee871efa7fbed.png";